var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont",domProps:{"innerHTML":_vm._s(_vm.translated.text? _vm.translated.text.replace(/\n/g, '<br>') : _vm.item.translation[0].data.text )}})
}
var staticRenderFns = []

export { render, staticRenderFns }